import React, { memo, useState } from 'react';
import deepEqual from 'deep-equal';
import clsx from 'clsx';

import FilterTips from './FilterTips';

import './FilterSection.scss';

function FilterSection({ children, filters, className }) {
  const [appliedFilters, setAppliedFilters] = useState([]);

  const handleApplyFilters = (newOptions) => {
    if (!deepEqual(appliedFilters, newOptions)) {
      setAppliedFilters(newOptions);
    }
  };

  const handleRemoveFilter = (idToRemove) => {
    setAppliedFilters((prevFilter) => prevFilter.filter(({ id }) => id !== idToRemove));
  };

  return (
    <div className={clsx('filter-section', className)}>
      <div className={clsx('filter-section_filters', className && `${className}__filters`)}>
        {filters({ selectedFilters: appliedFilters, onApply: handleApplyFilters })}
      </div>
      {appliedFilters.length ? <FilterTips appliedFilters={appliedFilters} onRemove={handleRemoveFilter} /> : null}
      <div className={clsx('filter-section_content', className && `${className}__content`)}>
        {children({ appliedFilters, onApply: handleApplyFilters })}
      </div>
    </div>
  );
}

export default memo(FilterSection);
